import {
  ArticleTile,
  ArticleTileProps,
  WhiskyArticleTile,
} from "../article-tile";

import { Box } from "@vinomofo/components";
import { DividerLink } from "../../divider-link";

export interface ArticlesBlockProps {
  articles: Array<ArticleTileProps>;
  isLoading?: boolean;
  isWhiskymofo?: boolean;
}

export const ArticlesBlock = ({
  articles,
  isLoading = false,
  isWhiskymofo = false,
}: ArticlesBlockProps): JSX.Element => {
  if (articles.length === 0) return null;

  const [featuredArticle, ...otherArticles] = articles;
  const articlesPath = isWhiskymofo ? "/whiskymofo-articles/" : "/articles/";

  return isWhiskymofo ? (
    <Box>
      <Box
        display="flex"
        flexDirection={["column", "column", "row"]}
        gridGap={["15px 10px", "20px"]}
        alignItems="start"
        pb="15px"
        mb={4}
      >
        <WhiskyArticleTile
          {...featuredArticle}
          isLoading={isLoading}
          isFeatured
          key={featuredArticle.id}
        />
        <Box
          display="flex"
          flexDirection="column"
          gridGap={["15px 25px", "35px"]}
          width={["100%", "100%", "50%"]}
          mt={["25px", "25px", "0"]}
        >
          {otherArticles.map((article) => {
            return (
              <WhiskyArticleTile
                key={article.id}
                {...article}
                isLoading={isLoading}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  ) : (
    <Box>
      <Box
        display="grid"
        gridGap={["20px 10px", "25px", "30px"]}
        gridTemplateColumns={["1fr", "1fr 1fr"]}
        alignItems="start"
        mb={4}
      >
        <ArticleTile
          key={featuredArticle.id}
          {...featuredArticle}
          isLoading={isLoading}
          isFeatured
        />
        <Box
          display="grid"
          gridGap={["20px 10px", "25px", "30px"]}
          gridTemplateColumns="1fr 1fr"
        >
          {otherArticles.map((article, i) => {
            return (
              <ArticleTile
                key={article.id}
                {...article}
                isLoading={isLoading}
              />
            );
          })}
        </Box>
      </Box>
      {!isLoading && (
        <DividerLink to={articlesPath} label="View all stories" isExternal />
      )}
    </Box>
  );
};
